import { createAction } from '@reduxjs/toolkit'

import { CustomerStatusState } from './types'

export const resetCustomerStatusAction = createAction<void>('customer-status/reset-customer-status')
export const setCustomerStatusAction = createAction<CustomerStatusState>('customer-status/set-customer-status')
export const setCustomerStatusLoadedAction = createAction<boolean>('customer-account/set-customer-status-loaded')
